import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Container } from 'components/layout/Grid/'
import { resetErrorMessage, setErrorMessage } from 'actions/app'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import AccountTransactionsView from 'views/AccountsAndLoans/AccountTransactions'

class AccountTransactions extends Component {
  static propTypes = {
    accountsAndLoans: PropTypes.object.isRequired,
    currentUser: PropTypes.object,
    selectedPartner: PropTypes.object,
  }
  static defaultProps = {
    selectedPartner: null,
    currentUser: null,
  }
  componentDidMount() {
    if (Object.keys(this.props.accountsAndLoans.selectedAccount).length === 0) {
      // window.history.go(-1) --
      // eslint-disable-next-line react/prop-types
      this.props.history.goBack()
    }
  }

  render() {
    const { accountsAndLoans, currentUser, selectedPartner } = this.props
    return (
      <Container>
        <AccountTransactionsView
          accountsAndLoans={accountsAndLoans}
          currentUser={currentUser}
          selectedPartner={selectedPartner}
        />
      </Container>
    )
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  accountsAndLoans: state.accountsAndLoans,
  selectedPartner: (Object.keys(state.personalinfos.selectedPartner).length === 0 && sessionStorage.getItem('SelectedPartner') !== null ?
    JSON.parse(sessionStorage.getItem('SelectedPartner')) :
    state.personalinfos.selectedPartner),
})

export default withRouter(connect(mapStateToProps, {
  resetErrorMessage,
  setErrorMessage,
})(AccountTransactions))



// WEBPACK FOOTER //
// ./src/containers/AccountTransactions.js